var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditsettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip03617338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61914 15.2798H4.9991L13.8715 5.85286C14.3197 5.37663 14.5715 4.73074 14.5715 4.05725C14.5715 3.38377 14.3197 2.73787 13.8715 2.26165C13.4233 1.78542 12.8154 1.51788 12.1815 1.51788C11.5477 1.51788 10.9398 1.78542 10.4915 2.26165L1.61914 11.6886V15.2798Z",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71484 3.2381L12.9529 6.67857",
    stroke: "#FF6019",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip03617338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditsettingsIcon);
export default __webpack_public_path__ + "static/media/EditsettingsIcon.5b3ea851.svg";
export { ForwardRef as ReactComponent };